// Dateinamen der Ablage – ausschließlich über die Backend-Logik (_shared/dokument-ablage/name.ts, Spec 2026-08-05).
// Die Datei hat keine Abhängigkeiten und wird direkt eingebunden, damit UI und Edge Function nie auseinanderlaufen.

import { baueDateiname } from '../../supabase/functions/_shared/dokument-ablage/name';

export { baueDateiname, dateiEndung, loeseZielpfad } from '../../supabase/functions/_shared/dokument-ablage/name';

const SCHEMA = /^(\d{2})_(\d{2})_(\d{4})_([^_]+)_(.+)\.([A-Za-z0-9]+)$/;

/**
 * Vorgeschlagener Name, wenn vor dem Ablegen das Zielobjekt wechselt: Datum, Wort und Beschreibung bleiben,
 * die Objektnummer wird ersetzt. Passt der Name nicht ins App-Schema (von Hand geändert), bleibt er unverändert.
 */
export function mitObjektnummer(name: string, objektnummer: string | null | undefined): string {
  const m = SCHEMA.exec(name.trim());
  if (!m) return name;
  const [, tag, monat, jahr, , rest, ext] = m;
  const datum = new Date(Date.UTC(Number(jahr), Number(monat) - 1, Number(tag)));
  if (Number.isNaN(datum.getTime())) return name;
  return baueDateiname({ objektnummer, datum, dokumentWort: '', beschreibung: rest, ext });
}
